import { useSearchParams } from 'react-router-dom';

import { LearnerPreviewBanner } from '@/platform/components/LearnerPreviewBanner';
import { TierUpgradeToast } from '@/platform/components/TierUpgradeToast';
import { useAuthStore } from '@/platform/stores/useAuthStore';
import { CatEdgeAuthProvider } from '../adapters/CatEdgeAuthProvider';
import { AppLayout, CatEdgeConfigProvider } from '../catedge';
import { learnerShellConfig } from '../config/learnerShellConfig';

export default function LearnerShell() {
  const user = useAuthStore((state) => state.user);
  const [searchParams] = useSearchParams();
  const showLearnerPreviewBanner =
    user?.role === 'admin' && searchParams.get('adminPreview') === '1';
  const returnTo = searchParams.get('returnTo') || '/admin';

  return (
    <CatEdgeConfigProvider config={learnerShellConfig}>
      <CatEdgeAuthProvider>
        <AppLayout
          contentTop={
            showLearnerPreviewBanner ? <LearnerPreviewBanner returnTo={returnTo} /> : undefined
          }
        />
        <TierUpgradeToast />
      </CatEdgeAuthProvider>
    </CatEdgeConfigProvider>
  );
}
